import BaseService from "src/packages/BaseService";

export default class InvitationService extends BaseService {
	static get className () {
		return "invitation";
	}

	static async sendInvitations(emails) {
		return (await BaseService.getService().post("invitation",{emails})).data;
	}
}
